<div [hidden]="forgotUserName.isEmailSent">
  <div class="flex-header">
    <span class="mat-dialog-title" *ngIf="classicSetPassword">Set Password</span>
    <span class="mat-dialog-title" *ngIf="!classicSetPassword">Reset Your <span *ngIf="loginSettings.TabSpecificForgotPasswordLink">
      <span *ngIf="userType==1">Staff</span>
        <span *ngIf="userType==2">Parent</span>
        <span *ngIf="userType==3">Student</span>&nbsp;</span>Password</span>
  </div>
  <div class="flex-content">
    <form [formGroup]="forgotPasswordForm" *ngIf="!(forgotPassword.isEmailSent) && !classicSetPassword">
      <div *ngIf="userType!=2||loginSettings.V10==true">
        <tyl-form-field label="Username" style="width: 100%">
          <input matInput
                 id="userNameField"
                 name="Username"
                 formControlName="userName"
                 aria-label="Username" required/>
        </tyl-form-field>
      </div>
      <div *ngIf="userType==2 && loginSettings.V10==false">
        <tyl-form-field label="Email Address" style="width: 100%">
          <input matInput
                 id="emailAddressField"
                 name="Email Address"
                 formControlName="emailAddress"
                 aria-label="Email Address"/>
        </tyl-form-field>
      </div>
    </form>
    <table *ngIf="!(forgotPassword.isEmailSent) && !classicSetPassword">
      <tr>
        <td style="padding-top:10px;">
          <span *ngIf="userType==2 && loginSettings.V10==false && !classicSetPassword">A link to reset your password will be sent to this address.</span>
          <span *ngIf="userType==2 && loginSettings.V10==false && classicSetPassword">A link to set your password will be sent to this address.</span>
          <span *ngIf="userType!=2||loginSettings.V10==true">A link to reset your password will be sent to the email address associated with this username.</span>
        </td>
      </tr>
      <tr>
        <td style="padding-top:20px;" *ngIf="userType!=2||loginSettings.V10==true">
          <button type="button" class="btn btn-link" style="padding-bottom: 10px;" (click)="forgotUserNameClick()"
                  *ngIf="loginSettings.ShowForgotUserNameLink" aria-label="Forgot your username"> Forgot your username?
          </button>
        </td>
        <td style="padding-top:20px; padding-bottom: 10px" *ngIf="userType==2 && loginSettings.V10==false">
          NOTE : Your Username is your email address.
        </td>
      </tr>
    </table>
    <table *ngIf="!(forgotPassword.isEmailSent) && classicSetPassword">
      <tr>
        <td>
          The link you used to access this page has expired.
        </td>
      </tr>
      <tr>
        <td style="padding-top:15px;">
          Please enter your email address and a new link will be sent.
        </td>
      </tr>
      <tr id="trUserName">
        <td style="padding-top:5px;">
          <form [formGroup]="forgotPasswordForm">
            <tyl-form-field label="Email Address" style="width: 100%">
              <input matInput style="width:350px;" maxlength="100"
                     id="??emailAddressField"
                     name="Email Address"
                     formControlName="emailAddress"
                     aria-label="Email Address"/>
            </tyl-form-field>
            <div *ngIf="emailAddress.invalid && formErrors"
                 class="alert alert-danger">
              <div *ngIf="emailAddress.errors.required">
                Email Address is required.
              </div>
            </div>
          </form>
        </td>
      </tr>
    </table>
    <div *ngIf="forgotPassword.isEmailSent">
          <span *ngIf="userType!=2||loginSettings.V10==true">
              A link will be sent to the email address associated with this <span
            *ngIf="loginSettings.TabSpecificForgotPasswordLink"><span *ngIf="userType==1">staff</span><span
            *ngIf="userType==2">parent</span><span *ngIf="userType==3">student</span>&nbsp;</span>username.
          </span>
      <span *ngIf="userType==2 && loginSettings.V10==false">
              <span *ngIf="!classicSetPassword">A link to reset your password will be sent to this address.</span>
              <span *ngIf="classicSetPassword">A link to set your password will be sent to this address.</span>
          </span>
    </div>
    <div *ngIf="forgotPassword.isEmailSent" style="padding-top:20px;">
      NOTE: Remember to look in your Junk or Spam folder too.
    </div>
    <div style="padding-top:20px;" *ngIf="loginSettings.V10 && forgotPassword.isEmailSent">
      For additional assistance, please contact the {{loginSettings.CountryCode == 'CAN' ? 'division' :
      'district'}}{{loginSettings.ShowLoginAssistanceInfo ? ': ' : '.'}}
      <span *ngIf="loginSettings.ShowLoginAssistanceInfo">
              <span *ngIf="loginSettings.UsernamePasswordRequestEmail != ''">{{loginSettings.UsernamePasswordRequestEmail}}</span>
              <span
                *ngIf="loginSettings.UsernamePasswordRequestEmail != '' && loginSettings.UsernamePasswordRequestPhone != ''"> or </span>
              <span *ngIf="loginSettings.UsernamePasswordRequestPhone != ''">({{loginSettings.UsernamePasswordRequestPhone.substring(0,3)}}) {{loginSettings.UsernamePasswordRequestPhone.substring(3,6)}}-{{loginSettings.UsernamePasswordRequestPhone.substring(6)}}</span>
          </span>
    </div>
  </div>
  <div class="flex-footer">
    <div class="flex-footer-right">
      <tyl-button image="save.png" label="Continue" (clickEvent)="continueClick()"
                  *ngIf="!(forgotPassword.isEmailSent)"
                  aria-label="Continue"></tyl-button>
      <tyl-button image="Cancel.png" label="{{forgotPassword.isEmailSent ? 'Close' : 'Cancel'}}"
                  (clickEvent)="cancelClick()" aria-label="Cancel"></tyl-button>
    </div>
  </div>
</div>
